module.exports = __webpack_public_path__ + "img/taqu.0f516ca5.png";